import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../../routes/private-route";
import { getDreamCasinoGames } from "../../redux/slices/games/casino/dreamCasinoGameListSlice";

import { checkImageURL } from "../../helper/utils";

import Evolution from "../../assets/images/user.jpg";
import Filter from "../../assets/images/svgs/filter 1.svg";

const CasinoGames = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { category } = useParams();
  const { gameSearch, theme } = useTheme();
  const { t } = useTranslation();
  const {
    loading: loadingGames,
    error,
    data,
  } = useSelector((state) => state.getDreamCasinoGames);

  const Category = decodeURIComponent(category);

  const configData = useSelector((state) => state.config.data);
  const {
    loading: profileLoading,
    error: profileError,
    data: profileData,
  } = useSelector((state) => state.getProfile);

  const [form, setForm] = useState({ category: "", provider: "" });

  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState(false);
  const [providers, setProviders] = useState([]);
  const [all, setAll] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (Category) {
      const formattedCategory =
        Category.charAt(0).toUpperCase() + Category.slice(1).toLowerCase();

      setAll([]);
      setPage(1);
      setForm((prev) => ({ ...prev, category: formattedCategory }));
    }
  }, [Category]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 300 // 300px before bottom
      ) {
        if (!loading && hasMore) {
          setPage((prev) => prev + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    console.log(66, gameSearch);
    setAll([]);
    setPage(1);
  }, [gameSearch]);

  useEffect(() => {
    // if (profileData) {
    getData(page);
    // } else {
    //   toast.warn("Please login to continue");
    //   navigate("/signin-username");
    // }
  }, [page, form, gameSearch, profileData]);

  useEffect(() => {
    if (configData?.casinoCategories) {
      setCategories(configData.casinoCategories);
    }
    if (configData?.casinoProviders) {
      setProviders(configData.casinoProviders);
    }
  }, [configData]);

  const getData = (pageNumber) => {
    console.log(profileData?.user?.parent_user_id, configData?._id, 73);
    dispatch(
      getDreamCasinoGames({
        page: pageNumber,
        limit: 10,
        perpage: 20,
        search_by_category: form.category.trim(),
        search_by_provider: form.provider.trim(),
        search_by_text: gameSearch,
        parent_id: profileData?.user?.parent_user_id
          ? profileData?.user?.parent_user_id
          : configData?._id,
      })
    )
      .unwrap()
      .then((res) => {
        if (pageNumber === 1) {
          setAll((prev) => [...res.data]);
        } else {
          setAll((prev) => {
            const ids = new Set(prev.map((item) => item._id));
            const newItems = res.data.filter((item) => !ids.has(item._id));
            return [...prev, ...newItems];
          });
        }

        setHasMore(res.has_more);
      })
      .catch((error) => {
        toast.error(error.message);
        console.error("Failed :", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));
    setPage(1);
    setAll([]);
  };

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word, i) =>
        i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join("");
  };
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="my-3 mx-2">
      <div
        className={`d-flex justify-content-between position-relative ${
          isMobile && filter ? "filter-panel-group" : ""
        }`}
      >
        <h2 className="fw-bold hero-heading ms-2">
          {t(`CasinoGames.${toCamelCase(Category)}`)}
        </h2>
        <div
          className={`d-flex align-items-center ${
            isMobile && !filter ? "w-50 me-2" : "justify-content-between"
          }`}
        >
          <div class="filter-panel px-2  ">
            {filter && (
              <div
                className={`d-flex ${
                  isMobile ? "justify-content-between" : ""
                }`}
              >
                <div className="">
                  <label className="mb-1 mx-2 fs-12 form-label">Category</label>
                  <select
                    name={"category"}
                    value={form.category}
                    aria-label={`Category`}
                    data-control="select2"
                    data-placeholder={`Select`}
                    className="form-select mx-2 select-lng p-1 ps-2 cursor-pointer"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  >
                    <option value={""}>
                      <b>Select</b>
                    </option>
                    {categories?.map((item, index) => (
                      <option key={index} value={item.name} onClick={(e) => {}}>
                        <b>{item.name}</b>
                      </option>
                    ))}
                  </select>
                </div>

                <div className="">
                  <label className="mb-1 mx-2 fs-12 form-label">Provider</label>
                  <select
                    name={"provider"}
                    value={form.provider}
                    aria-label={`Provider`}
                    data-control="select2"
                    data-placeholder={`Select`}
                    className="form-select mx-2 select-lng p-1 ps-2 cursor-pointer"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  >
                    <option value={""}>
                      <b>Select</b>
                    </option>
                    {providers?.map((item, index) => (
                      <option key={index} value={item.name}>
                        <b>{item.name}</b>
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
          <div
            className={`p-1 text-center social-logo rounded-2 cursor-pointer ${
              isMobile && filter ? "align-self-end me-2 filter-size" : ""
            } `}
            onClick={() => {
              setFilter(!filter);
            }}
          >
            <img src={Filter} alt="" className=" w-80 h-100 svg-icon" />
          </div>
        </div>
      </div>

      {loadingGames && page == 1 && (
        <SkeletonTheme baseColor="#868686" highlightColor="#ffffff">
          <div className="grid-container">
            {[...Array(21)].map((_, i) => (
              <Skeleton height={200} className="my-1 grid-item" key={i} />
            ))}
          </div>
        </SkeletonTheme>
      )}

      <div className="grid-container mt-3">
        {all.map((item, index) => (
          <div
            key={index}
            className="text-center position-relative image-wrapper"
            onClick={() => {
              console.log(224, configData);

              if (
                configData?.totalBets?.length > 0 &&
                configData.betPerDayOfPlan <= configData.totalBets
              ) {
                toast.error(
                  `Not more than ${configData.betPerDayOfPlan} bets can be placed per day`
                );
              } else {
                navigate("/game-section", {
                  state: { game_id: item.game_id },
                });
              }
            }}
          >
            <img
              src={checkImageURL(item.url_thumb) ? item.url_thumb : Evolution}
              alt=""
              className="grid-item cursor-pointer"
            />

            {profileData && (
              <div className="image-overlay d-flex justify-content-center align-items-center gap-1 text-white text-center flex-column">
                {configData?.setting?.minimum_bet && (
                  <span>
                    {" "}
                    {t("bet.minBet")}: {configData?.setting?.minimum_bet}
                  </span>
                )}
                {configData?.setting?.maximum_bet && (
                  <span>
                    {" "}
                    {t("bet.maxBet")}: {configData?.setting?.maximum_bet}
                  </span>
                )}
                {configData?.setting?.max_loss && (
                  <span>
                    {" "}
                    {t("bet.maxLoss")}: {configData?.setting?.max_loss}
                  </span>
                )}
                {configData?.setting?.max_win && (
                  <span>
                    {" "}
                    {t("bet.maxWin")}: {configData?.setting?.max_win}
                  </span>
                )}
              </div>
            )}
            {/* Overlay for hover */}

            {!checkImageURL(item.url_thumb) && (
              <span
                className="position-absolute text-white fw-bold text-center"
                style={{
                  transform: "translate(-50%, 50%)",
                  top: "5%",
                  left: "50%",
                  zIndex: -1,
                }}
              >
                {item.game_name} <br /> {item.url_thumb}
              </span>
            )}
          </div>
        ))}

        {!loadingGames && all.length === 0 && (
          <span className="text-white">{t("Common.noDataFound")}</span>
        )}
        {loadingGames && page > 1 && <div className="loaderr"></div>}
      </div>
    </div>
  );
};

export default CasinoGames;
